import Vue, { watch } from 'vue'
import VueI18n from 'vue-i18n'

import { apiClient, logHttpFailure } from '@/plugins/http'
import { LOOKUP_REQUEST_CONFIG } from '@/plugins/http/policy'

Vue.use(VueI18n)

const locale = localStorage.getItem('lang') || 'ko'
const i18n = new VueI18n({
  locale,
  fallbackLocale: 'ko',
  silentTranslationWarn: true,
})

/**
 * 로케일 메시지를 서버에서 받아 갈아 끼운다 — 부팅·언어 전환마다 부르는 작은 조회라 가벼운 조회 프로필(짧은 타임아웃 +
 * 재시도, 잠금 로딩·토스트 없음)을 쓴다. 끝내 못 받으면 폴백 로케일 메시지(키가 곧 한국어 문장)로 조용히 남는다 — 그것이
 * 이 조회의 대체 동작이다.
 */
export async function fetchLocaleFromServer(locale) {
  try {
    const result = await apiClient
      .get(`/admin/api/lan/data/${locale}`, LOOKUP_REQUEST_CONFIG)
      .then((res) => res.data.data)

    if (!result) {
      throw new Error('Failed to fetch locale from server')
    }

    i18n.setLocaleMessage(locale, result)

    console.log('set locale message', locale, result)
  } catch (error) {
    logHttpFailure(error, 'Failed to fetch locale from server')
  }
}

// ★ 최초 로케일 조회는 여기서 하지 않는다 (14R P56). 모듈 평가 중에 요청을 내면 라우트가 확정되기 전이라 요청 시점의 라우트
// 스냅샷(12R P10)이 기본 레이아웃으로 찍히고, 그 요청이 403 이면 임베드 창(POS)에서도 세션을 끝내고 `/login` 으로 하드
// 이동했다. `main.js` 가 첫 라우트가 확정된 뒤(`router.onReady`) 마운트를 막지 않고 부른다. 로케일이 바뀔 때의 재조회는
// 아래 감시자 그대로다.

watch(
  () => i18n.locale,
  (newLocale) => {
    fetchLocaleFromServer(newLocale)
  }
)

export default i18n
